import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { FOODIE_MENU_SERVICE } from '../EndPoints';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

export const GetAllMeals = createAsyncThunk('menu/GetAllMeals', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(FOODIE_MENU_SERVICE.getAllMeals)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetAllCourseType = createAsyncThunk('menu/GetAllCourseType ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(FOODIE_MENU_SERVICE.getAllCourseType)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const GetAllItem = createAsyncThunk('menu/GetAllItem ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(FOODIE_MENU_SERVICE.getAllItem)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const GetMenuById = createAsyncThunk('menu/GetMenuById ', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .get(`${FOODIE_MENU_SERVICE.getMenuById}${params}`)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
export const CreateMenu = createAsyncThunk('menu/CreateMenu', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .post(FOODIE_MENU_SERVICE.createMenu, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
export const UpdateMenu = createAsyncThunk('menu/UpdateMenu', async (params, { dispatch, getState }) => {
    const response = await apiInstance
        .put(FOODIE_MENU_SERVICE.updateMenu, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
export const GetMenuByCafeteriaIdServingDate = createAsyncThunk(
    'menu/GetMenuByCafeteriaIdServingDate',
    async ({ cafeteriaId, servingDate, pagination }, { dispatch, getState }) => {
        const response = await apiInstance
            .post(`${FOODIE_MENU_SERVICE.getMenuByCafeteriaIdServingDate}${cafeteriaId}/${servingDate}`, pagination)
            .then(function (response) {
                return response;
            })
            .catch((error) => error.response);

        const { data, status, code } = response;
        return { data, status, code };
    },
);

export const DeleteDepartmentById = createAsyncThunk(
  'menu/deleteDepartmentById',
  async ({foodieMenuId, departmentId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(FOODIE_MENU_SERVICE.deleteDepartmentById(foodieMenuId, departmentId))
      .catch((error) => error.response);

    const { data, status } = response;
    return { data, status };
  }
);
export const DeleteMealTimeById = createAsyncThunk(
  'menu/deleteMealTimetById',
  async ({foodieMenuId, mealTimeId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(FOODIE_MENU_SERVICE.deleteMealTimeById(foodieMenuId, mealTimeId))
      .catch((error) => error.response);

    const { data, status } = response;
    return { data, status };
  }
);
export const DeleteUserById = createAsyncThunk(
  'menu/deleteUserById',
  async ({foodieMenuId, userId }, { dispatch, getState }) => {
    const response = await apiInstance
      .delete(FOODIE_MENU_SERVICE.deleteUserById(foodieMenuId, userId))
      .catch((error) => error.response);

    const { data, status } = response;
    return { data, status };
  }
);

export const GetAllMealForecast = createAsyncThunk(
    'menu/getAllMealForecast',
    async (params, { dispatch, getState }) => {
        const response = await apiInstance
            .post(FOODIE_MENU_SERVICE.getAllMealForecast, params)
            .then(function (response) {
                return response;
            })
            .catch((error) => error.response);

        const { data, status, code } = response;
        return { data, status, code };
    },
);
